import {useQuery} from "@tanstack/react-query"
import {handleError} from "helpers"
import {isEmpty, uniqBy} from "lodash"
import {useMemo} from "react"
import {retentionService} from "services"

type Props = {
    stages?: string[]
    enabled?: boolean
}

const useRetentionStageSettings = (props?: Props) => {
    const {stages, enabled = true} = props || {}

    const {data: stageMapping, isFetching: isLoadingRetentionStageSetting} = useQuery(
        ["retention-stage-setting"],
        () => retentionService.getAcademicStage(),
        {
            onError: (err) => {
                handleError(err)
            },
            enabled,
            initialData: {}
        }
    )

    const retentionStages = useMemo(() => {
        let results = []
        if (!isEmpty(stageMapping)) {
            const keys = Object.keys(stageMapping)
            for (let key of keys) {
                if (stages?.length) {
                    if (stages.includes(key)) {
                        results = results.concat(stageMapping[key])
                    }
                } else {
                    results = results.concat(stageMapping[key])
                }
            }
        }

        return uniqBy(results, "statusId")
    }, [stageMapping, stages])

    return {
        retentionStages,
        isLoadingRetentionStageSetting
    }
}

export {useRetentionStageSettings}
